// extracted by mini-css-extract-plugin
export var body = "_2z-1";
export var bodyPadded = "_2z-2";
export var chevron = "_2z-4";
export var chevronOpen = "_2z-5";
export var header = "_2z-0";
export var icon = "_2z-3";